import { isNil } from "lodash"
import moment from "moment"
import { Timestamp } from "helpers/types/dates"

export function formatTimestamp(timestamp: Timestamp | null | undefined): string {
  if (isNil(timestamp)) {
    return "--"
  }

  return moment(timestamp).format("LTS")
}

export function formatPrice(price: string): string {
  const num = parseFloat(price)
  if (isNaN(num)) return price
  return num.toFixed(2)
}

type ChangeDirection = "positive" | "negative" | "neutral"

export function getChangeDirection(change: number | null | undefined): ChangeDirection {
  if (isNil(change) || change === 0) {
    return "neutral"
  }
  return change > 0 ? "positive" : "negative"
}
